/**
 * Backend API path constants. Base URL is applied by services/apiClient.
 * Use these instead of string literals for all backend routes.
 */

// Cart
export const CART = '/api/cart';
export const CART_ADD = '/api/cart/add';
export const CART_UPDATE = '/api/cart/update';
export const CART_ACTIONS = '/api/cart/actions';
export const CART_MERGE = '/api/cart/merge';
export const CART_SYNC_PRICES = '/api/cart/sync-prices';
export const CART_SHARED = '/api/cart/shared';
export const CART_SHARED_BY_TOKEN = (token: string): string => `/api/cart/shared/${token}`;
export const CART_CREATE_SHARE_TOKEN = '/api/cart/create-share-token';

// Orders
export const ORDERS = '/api/orders';
export const ORDERS_BY_ID = (id: string): string => `/api/orders/${id}`;
export const PLACE_ORDER_INVOICE = '/api/place-order-invoice';

// Payment
export const CREATE_PAYMENT_INTENT = '/api/create-payment-intent';
export const PAYMENT_CREATE = '/api/payment/create';
export const CHECKOUT_SESSION = (id: string): string => `/api/checkout-session/${id}`;
export const PAYMENT_INTENT = (id: string): string => `/api/payment-intent/${id}`;

// Products
export const PRODUCTS = '/api/products';
export const PRODUCTS_BY_ID = (id: string): string => `/api/products/${id}`;
export const PRODUCTS_KEY = (key: string): string => `/api/products/key/${key}`;
export const PRODUCT_PROJECTIONS = '/api/product-projections';
export const PRODUCT_DISCOUNTS = (id: string): string => `/api/product-discounts/${id}`;
export const EVENT_PRODUCTS = (eventKey: string): string => `/api/events/${eventKey}/products`;

// Categories
export const CATEGORIES = '/api/categories';
export const CATEGORIES_BY_ID = (id: string): string => `/api/categories/id/${id}`;
export const CATEGORIES_BY_KEY = (key: string): string => `/api/categories/key/${key}`;

// Other
export const CUSTOMER_GROUPS = '/api/customer-groups';
export const PROJECT = '/api/project';
export const STORES = '/api/stores';
export const STORES_KEY = (key: string): string => `/api/stores/key/${key}`;
export const TAX_CALCULATE = '/api/tax/calculate';
export const EMAIL_SHARE_BASKET = '/api/email/share-basket';

// Loqate Endpoints
export const LOQATE_FIND = '/api/loqate/find';
export const LOQATE_RETRIEVE = '/api/loqate/retrieve';
export const LOQATE_RULES = '/api/loqate/rules';
export const LOQATE_VERIFY = '/api/loqate/verify';
